<tui-scrollbar class="chat-members-list">
  <div class="chat-members-list__header">
    <chat-details-item
      [icon]="'users'"
      [label]="'components.internalMessenger.labels.members' | translate"
      [actions]="headerActions"
    ></chat-details-item>
  </div>

  <div class="chat-members-list__body">
    <div class="list">
      <ng-container *ngIf="!!members; else tmpLoading">
        <ng-container *ngIf="members.length; else tmpNoData">
          <ng-container *ngFor="let member of members">
            <chat-members-list-item
              class="list-item"
              [routerLink]="'/association-users/' + member.userId"
              routerLinkActive="list-item_selected"
              [member]="member"
              [actions]="itemActions"
            ></chat-members-list-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <ng-template #tmpLoading>
      <app-skeleton-wrapper [loading]="true"></app-skeleton-wrapper>
    </ng-template>

    <ng-template #tmpNoData>
      <div class="no-data">
        <p>{{ 'components.internalMessenger.labels.noData' | translate }}</p>
      </div>
    </ng-template>
  </div>
</tui-scrollbar>
